// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { ServicesDescriptionCoachingFocusFragmentDoc } from '../../../__generated-gql-types__/ServicesDescription.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BookCoachingTimeFormCoachFragment = {
  __typename?: 'Coach';
  id: string;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  mostRecentOrder?: {
    __typename?: 'Order';
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type BookCoachingTimeFormCoachingFocusFragment = {
  __typename?: 'CoachingFocus';
  id: string;
  name: string;
};

export type BookCoachingTimeFormUpdateOrderMutationVariables = Types.Exact<{
  id: Types.Scalars['OrderUrn']['input'];
  hourlyOrder?: Types.InputMaybe<Types.HourlyOrderInput>;
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type BookCoachingTimeFormUpdateOrderMutation = {
  __typename?: 'Mutation';
  updateOrder: { __typename?: 'Order'; id: string };
};

export type BookCoachingTimeFormCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  hourlyOrder: Types.HourlyOrderInput;
  numberOfCharges: Types.Scalars['Int']['input'];
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
}>;

export type BookCoachingTimeFormCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: { __typename?: 'Order'; id: string };
};

export type BookCoachingTimeFormInitialLoadQueryVariables = Types.Exact<{
  tier: Types.SkuTier;
  period?: Types.InputMaybe<Types.SubscriptionInterval>;
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type BookCoachingTimeFormInitialLoadQuery = {
  __typename?: 'Query';
  skus: {
    __typename?: 'SkuBatchResponse';
    results: Array<{
      __typename?: 'Sku';
      id: string;
      name: string;
      tier: Types.SkuTier;
      period: Types.SubscriptionInterval;
      price: number;
      numberOfSessions: number;
      unitPrice: number;
    }>;
  };
  singleHourSku: { __typename?: 'Sku'; id: string; unitPrice: number };
  activeCustomerSubscriptions: Array<{
    __typename?: 'CustomerSubscription';
    id: string;
    useSkuUnitPrice: boolean;
    sku: { __typename?: 'Sku'; id: string; unitPrice: number };
  }>;
};

export const BookCoachingTimeFormCoachFragmentDoc = gql`
  fragment BookCoachingTimeForm_Coach on Coach {
    id
    hourlyRate
    user {
      id
      firstName
      lastName
      pictureLink
    }
    mostRecentOrder {
      hourlyOrder {
        timeInMinute
      }
    }
    tier
  }
`;
export const BookCoachingTimeFormCoachingFocusFragmentDoc = gql`
  fragment BookCoachingTimeForm_CoachingFocus on CoachingFocus {
    ...ServicesDescription_CoachingFocus
  }
  ${ServicesDescriptionCoachingFocusFragmentDoc}
`;
export const BookCoachingTimeFormUpdateOrderDocument = gql`
  mutation BookCoachingTimeForm_UpdateOrder(
    $id: OrderUrn!
    $hourlyOrder: HourlyOrderInput
    $categoryUrn: CategoryUrn
  ) {
    updateOrder(id: $id, hourlyOrder: $hourlyOrder, categoryUrn: $categoryUrn) {
      id
    }
  }
`;
export type BookCoachingTimeFormUpdateOrderMutationFn = Apollo.MutationFunction<
  BookCoachingTimeFormUpdateOrderMutation,
  BookCoachingTimeFormUpdateOrderMutationVariables
>;

/**
 * __useBookCoachingTimeFormUpdateOrderMutation__
 *
 * To run a mutation, you first call `useBookCoachingTimeFormUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookCoachingTimeFormUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookCoachingTimeFormUpdateOrderMutation, { data, loading, error }] = useBookCoachingTimeFormUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useBookCoachingTimeFormUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookCoachingTimeFormUpdateOrderMutation,
    BookCoachingTimeFormUpdateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookCoachingTimeFormUpdateOrderMutation,
    BookCoachingTimeFormUpdateOrderMutationVariables
  >(BookCoachingTimeFormUpdateOrderDocument, options);
}
export type BookCoachingTimeFormUpdateOrderMutationHookResult = ReturnType<
  typeof useBookCoachingTimeFormUpdateOrderMutation
>;
export type BookCoachingTimeFormUpdateOrderMutationResult =
  Apollo.MutationResult<BookCoachingTimeFormUpdateOrderMutation>;
export type BookCoachingTimeFormUpdateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    BookCoachingTimeFormUpdateOrderMutation,
    BookCoachingTimeFormUpdateOrderMutationVariables
  >;
export const BookCoachingTimeFormCreateOrderDocument = gql`
  mutation BookCoachingTimeForm_CreateOrder(
    $coachUrn: CoachUrn!
    $hourlyOrder: HourlyOrderInput!
    $numberOfCharges: Int!
    $categoryUrn: CategoryUrn
  ) {
    createOrder(
      coachUrn: $coachUrn
      hourlyOrder: $hourlyOrder
      numberOfCharges: $numberOfCharges
      categoryUrn: $categoryUrn
    ) {
      id
    }
  }
`;
export type BookCoachingTimeFormCreateOrderMutationFn = Apollo.MutationFunction<
  BookCoachingTimeFormCreateOrderMutation,
  BookCoachingTimeFormCreateOrderMutationVariables
>;

/**
 * __useBookCoachingTimeFormCreateOrderMutation__
 *
 * To run a mutation, you first call `useBookCoachingTimeFormCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookCoachingTimeFormCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookCoachingTimeFormCreateOrderMutation, { data, loading, error }] = useBookCoachingTimeFormCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      hourlyOrder: // value for 'hourlyOrder'
 *      numberOfCharges: // value for 'numberOfCharges'
 *      categoryUrn: // value for 'categoryUrn'
 *   },
 * });
 */
export function useBookCoachingTimeFormCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BookCoachingTimeFormCreateOrderMutation,
    BookCoachingTimeFormCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    BookCoachingTimeFormCreateOrderMutation,
    BookCoachingTimeFormCreateOrderMutationVariables
  >(BookCoachingTimeFormCreateOrderDocument, options);
}
export type BookCoachingTimeFormCreateOrderMutationHookResult = ReturnType<
  typeof useBookCoachingTimeFormCreateOrderMutation
>;
export type BookCoachingTimeFormCreateOrderMutationResult =
  Apollo.MutationResult<BookCoachingTimeFormCreateOrderMutation>;
export type BookCoachingTimeFormCreateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    BookCoachingTimeFormCreateOrderMutation,
    BookCoachingTimeFormCreateOrderMutationVariables
  >;
export const BookCoachingTimeFormInitialLoadDocument = gql`
  query BookCoachingTimeForm_InitialLoad(
    $tier: SkuTier!
    $period: SubscriptionInterval
    $coachUrn: CoachUrn!
  ) {
    skus(tier: $tier, period: $period, count: 8) {
      results {
        id
        name
        tier
        period
        price
        numberOfSessions
        unitPrice
      }
    }
    singleHourSku: findSkuBySession(
      tier: $tier
      period: ONE_TIME
      numberOfSessions: 1
    ) {
      id
      unitPrice
    }
    activeCustomerSubscriptions: customerSubscriptions(
      coachUrn: $coachUrn
      statuses: [ACTIVE]
    ) {
      id
      useSkuUnitPrice
      sku {
        id
        unitPrice
      }
    }
  }
`;

/**
 * __useBookCoachingTimeFormInitialLoadQuery__
 *
 * To run a query within a React component, call `useBookCoachingTimeFormInitialLoadQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookCoachingTimeFormInitialLoadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookCoachingTimeFormInitialLoadQuery({
 *   variables: {
 *      tier: // value for 'tier'
 *      period: // value for 'period'
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useBookCoachingTimeFormInitialLoadQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  > &
    (
      | {
          variables: BookCoachingTimeFormInitialLoadQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  >(BookCoachingTimeFormInitialLoadDocument, options);
}
export function useBookCoachingTimeFormInitialLoadLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  >(BookCoachingTimeFormInitialLoadDocument, options);
}
export function useBookCoachingTimeFormInitialLoadSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    BookCoachingTimeFormInitialLoadQuery,
    BookCoachingTimeFormInitialLoadQueryVariables
  >(BookCoachingTimeFormInitialLoadDocument, options);
}
export type BookCoachingTimeFormInitialLoadQueryHookResult = ReturnType<
  typeof useBookCoachingTimeFormInitialLoadQuery
>;
export type BookCoachingTimeFormInitialLoadLazyQueryHookResult = ReturnType<
  typeof useBookCoachingTimeFormInitialLoadLazyQuery
>;
export type BookCoachingTimeFormInitialLoadSuspenseQueryHookResult = ReturnType<
  typeof useBookCoachingTimeFormInitialLoadSuspenseQuery
>;
export type BookCoachingTimeFormInitialLoadQueryResult = Apollo.QueryResult<
  BookCoachingTimeFormInitialLoadQuery,
  BookCoachingTimeFormInitialLoadQueryVariables
>;
